import logo from './logo.svg';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from './pages/landing';
import Dashboard from './pages/dashboard';
import Lecture from './pages/lecture';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from './constants';
import "./App.css";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />}/>
        <Route path="/home" element={<Dashboard />}/>
        <Route path="/lecture" element={<Lecture />}/>
      </Routes>
    </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
